import { combineReducers } from 'redux'
import { polyglotReducer } from 'redux-polyglot'
import accountReducer from '../reducers/account'
import addonsReducer from '../reducers/addons'
import appReducer from '../reducers/app'
import billingReducer from '../reducers/billing'
import cartReducer from '../reducers/cart'
import channelsReducer from '../reducers/channels'
import checkoutReducer from '../reducers/checkout'
import checkoutAppReducer from '../reducers/checkout-app'
import devicesReducer from '../reducers/devices'
import dvrReducer from '../reducers/dvr'
import loginReducer from '../reducers/login'
import packagesReducer from '../reducers/packages'
import pagesReducer from '../reducers/pages'
import questionsReducer from '../reducers/questions'
import recommendationsReducer from '../reducers/recommendations'
import registerReducer from '../reducers/register'
import searchReducer from '../reducers/search'
import subscriptionReducer from '../reducers/subscription'
import thankyouReducer from '../reducers/thankyou'
import ticketsReducer from '../reducers/tickets'
import topicsReducer from '../reducers/topics'
import videoReducer from '../reducers/video'
import videoCategoryReducer from '../reducers/video-category'
import videoLibraryReducer from '../reducers/video-library'
import youtubeReducer from '../reducers/youtube'
import forgotPasswordReducer from '../reducers/forgot-password'

const rootReducer = combineReducers({
  account: accountReducer,
  addons: addonsReducer,
  app: appReducer,
  billing: billingReducer,
  cart: cartReducer,
  channels: channelsReducer,
  checkout: checkoutReducer,
  checkoutApp: checkoutAppReducer,
  devices: devicesReducer,
  dvr: dvrReducer,
  recommendations: recommendationsReducer,
  login: loginReducer,
  packages: packagesReducer,
  polyglot: polyglotReducer,
  register: registerReducer,
  search: searchReducer,
  subscription: subscriptionReducer,
  thankyou: thankyouReducer,
  video: videoReducer,
  videoCategory: videoCategoryReducer,
  videoLibrary: videoLibraryReducer,
  youtube: youtubeReducer,
  pages: pagesReducer,
  questions: questionsReducer,
  topics: topicsReducer,
  tickets: ticketsReducer,
  forgotPassword: forgotPasswordReducer,
})

export default rootReducer
